import styled from "styled-components";

export const Container = styled.div`
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.COLORS.SECONDARY};

    @media (max-width: 360px) {
    width: 60%;

    }
    @media (max-width: 768px) {
      width: 60%;
    }
`;
export const SubContainer = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding-block: 10px;
  flex-direction: column;
`;

export const ContainerImg = styled.div`
  width: 90%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-block: 10px;
`;
export const Logo = styled.img`
  width: 10%;
  border-radius: 100%;
`;
export const Title = styled.h1`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 16px;
  align-items: center;
  margin: 0;
  margin-left: 10px;

   @media (max-width: 768px) {
       font-size: 13px;
    }
`;
export const Description = styled.p`
  color: ${({ theme }) => theme.COLORS.DESCRIPTION};
  font-size: 15px;
  font-weight: 500;
  margin: 0;

   @media (max-width: 768px) {
       font-size: 12px;
    }
`;
export const ExtraInfo = styled.div`
    display: flex;
    justify-content: flex-start;
    width: 90%;

       @media (max-width: 768px) {
       flex-direction: column;
    }
`;
export const Date = styled.span`
    font-size: 15px;
    color: ${({ theme }) => theme.COLORS.DESCRIPTION};
    margin-left: 10px;

      @media (max-width: 768px) {
       font-size: 13px;
      margin-left: 0;

    }
`;

export const Rating = styled.span`
    font-size: 15px
    ${({ theme }) => theme.COLORS.DESCRIPTION};

     @media (max-width: 768px) {
       font-size: 13px;
    }
`;